import React, { useState, useEffect } from 'react';
import { getCurrentUser } from 'aws-amplify/auth';
import ProfileHeader from './ProfileHeader';
import DemographicInfo from './DemographicInfo';
import GolfPreferences from './GolfPreferences';
import SubscriptionManagement from './SubscriptionManagement';
import AccountSettings from './AccountSettings';
import './Profile.css';

const Profile = () => {
  const [activeTab, setActiveTab] = useState('demographics');
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saveStatus, setSaveStatus] = useState({ show: false, success: false, message: '' });

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userData = await getCurrentUser();
        setUser(userData);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching user data:', error);
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const showSaveStatus = (success, message) => {
    setSaveStatus({
      show: true,
      success,
      message
    });

    setTimeout(() => {
      setSaveStatus({ show: false, success: false, message: '' });
    }, 3000);
  };

  if (loading) {
    return <div className="profile-loading">Loading profile information...</div>;
  }

  return (
    <div className="profile-container">
      <ProfileHeader user={user} />
      
      {saveStatus.show && (
        <div className={`save-status ${saveStatus.success ? 'success' : 'error'}`}>
          {saveStatus.message}
        </div>
      )}
      
      <div className="profile-tabs">
        <button 
          className={activeTab === 'demographics' ? 'active' : ''} 
          onClick={() => handleTabChange('demographics')}
        >
          Personal Information
        </button>
        <button 
          className={activeTab === 'preferences' ? 'active' : ''} 
          onClick={() => handleTabChange('preferences')}
        >
          Golf Preferences
        </button>
        <button 
          className={activeTab === 'subscription' ? 'active' : ''} 
          onClick={() => handleTabChange('subscription')}
        >
          Subscription
        </button>
        <button 
          className={activeTab === 'account' ? 'active' : ''} 
          onClick={() => handleTabChange('account')}
        >
          Account Settings
        </button>
      </div>
      
      <div className="profile-content">
        {activeTab === 'demographics' && (
          <DemographicInfo user={user} onSave={(success, message) => showSaveStatus(success, message)} />
        )}
        
        {activeTab === 'preferences' && (
          <GolfPreferences user={user} onSave={(success, message) => showSaveStatus(success, message)} />
        )}
        
        {activeTab === 'subscription' && (
          <SubscriptionManagement user={user} onSave={(success, message) => showSaveStatus(success, message)} />
        )}
        
        {activeTab === 'account' && (
          <AccountSettings user={user} onSave={(success, message) => showSaveStatus(success, message)} />
        )}
      </div>
    </div>
  );
};

export default Profile;
